/** Keep "Breakin' Bread" on one line: a title that wraps breaks before the
 *  brand, never inside it ("Nobody owns / Breakin' Bread", Gordon 2026-11-02). */
export const keepBrandTogether = (s: string) => s.replace(/Breakin([’'])\s+Bread/g, 'Breakin$1 Bread');
